import {
  boxesByPage,
  citationBoxes,
  focusedBoxes,
  focusedTarget,
  primaryPage,
} from './citationHighlightTargets'

function focusSectionId(citation, targetIndex) {
  const focused = focusedTarget(citation, targetIndex)
  if (focused?.span?.block_id != null) return String(focused.span.block_id)
  if (citation?.span?.block_id != null) return String(citation.span.block_id)
  if (typeof citation?.section_path === 'string') return citation.section_path
  if (Array.isArray(citation?.section_path) && citation.section_path.length) {
    return String(citation.section_path[citation.section_path.length - 1])
  }
  return null
}

export function previewKind(citation) {
  return citation?.kind === 'row' ? 'spreadsheet' : 'pdf'
}

export function focusTarget(citation, targetIndex = -1) {
  return {
    focusPage: primaryPage(citation, targetIndex),
    focusSectionId: focusSectionId(citation, targetIndex),
  }
}

export function previewPayload(citation, kind, targetIndex = -1) {
  if (kind === 'spreadsheet') return { columns: [], rows: [] }
  const url = citation.preview_url || citation.derived_url || citation.url || ''
  const page = primaryPage(citation, targetIndex)
  const focused = focusedBoxes(citation, targetIndex)
  return {
    ...(url ? { url } : {}),
    documentId: citation.doc_id,
    highlights: citationBoxes(citation, 'exact'),
    coarseHighlights: citationBoxes(citation, 'coarse'),
    highlightsByPage: boxesByPage(citation, 'exact'),
    coarseHighlightsByPage: boxesByPage(citation, 'coarse'),
    // The clicked claim's own boxes, so a page carrying several of them says
    // which one was asked for instead of highlighting them all alike.
    focusHighlightsByPage: focused.length ? { [page]: focused } : {},
    page,
  }
}
